// extracted by mini-css-extract-plugin
module.exports = {"container":"_6c97079b1b--container--cJJhp","header":"_6c97079b1b--header--RHqHo","expand":"_6c97079b1b--expand--mp6zx","expand_icon":"_6c97079b1b--expand_icon--LKz2n"};